module.exports = __webpack_public_path__ + "static/media/floculante.d0de5271.png";